import React from 'react';
import {Input} from "@chakra-ui/react";
import {Field} from "@/components";

export const InputView = ({ label, required, conditional, onChange,...props }) => {

    return (
        <Field
            label={`${label}${required ? '*' : ''} :`}
            {...props}
        >
            <Input
                onChange={e => onChange?.(e?.target?.value)}
                placeholder={label}
            />
        </Field>
    );
};

export default InputView;
